import { Translate } from '@dreryk/react-common';
import { CheckIcon, IconSize, IconWrapper, StyledFlex } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../../translations';

import { GynecologicalInterviewPregnancyConfirmationMark } from './GynecologicalInterviewPregnancyConfirmationMark';

type GynecologicalInterviewPregnancyBasicInfoProps = {
   readonly pregnancyConfirmed: boolean;
   readonly multiplePregnancy: boolean;
};

export const GynecologicalInterviewPregnancyBasicInfo = (
   props: GynecologicalInterviewPregnancyBasicInfoProps
): JSX.Element => {
   return (
      <StyledFlex direction={'column'} gap={'8px'}>
         <GynecologicalInterviewPregnancyConfirmationMark confirmed={props.pregnancyConfirmed} />
         {props.multiplePregnancy ? (
            <StyledFlex gap={'4px'} alignItems={'center'}>
               <IconWrapper testId={'multiplePregnancy'} size={IconSize.SMALLEST}>
                  <CheckIcon />
               </IconWrapper>
               <Translate>{visitPatientPregnancyStatusTranslationKeys.multiplePregnancy}</Translate>
            </StyledFlex>
         ) : null}
      </StyledFlex>
   );
};
